import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { BulkVerifyHubService } from 'src/app/shared/services/bulk-verify-hub.service';
import { TransactionsState } from 'src/app/shared/states/transactions/transactions.state';

@Component({
  selector: 'app-bulk-verify-pill-loader',
  templateUrl: './bulk-verify-pill-loader.component.html',
  styleUrls: ['../../../../shared/components/pill-loader/pill-loader.component.scss', './bulk-verify-pill-loader.component.scss'],
  providers: [BulkVerifyHubService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkVerifyPillLoaderComponent implements OnInit, OnDestroy {

  header = "Bulk Confirming Transactions";

  expanded = true;

  @Select(TransactionsState.bulkVerifyLoadedPercent) loadedPercent$: Observable<number>;

  constructor(private bulkVerifyHubService: BulkVerifyHubService) { 
  }
  
  ngOnInit(): void {
    if (!this.bulkVerifyHubService.isConnected()) {
      this.bulkVerifyHubService.startListening();
    }
  }

  onExpandCollapse(): void {
    event.stopPropagation();
    this.expanded = !this.expanded;
  }

  ngOnDestroy(): void {
    this.bulkVerifyHubService.ngOnDestroy();
  }

}
